import { ShieldCheck, MessageSquare, Wallet, Lock } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Hakkımızda</h1>
      <p className="text-lg text-slate-600 leading-relaxed mt-4">
        Ustayla, işveren ve hizmet alan kişiler ile usta ve hizmet verenleri bir araya getiren modern bir hizmet pazaryeridir.
        İnşaat, tadilat, dekorasyon, bakım ve onarım gibi birçok kategoride ilan ve teklif sistemi sunar.
      </p>
      <div className="bg-white rounded-2xl border border-slate-200/80 p-6 mt-8">
        <h2 className="text-xl font-bold text-slate-900">Ustayla'nın Rolü</h2>
        <p className="text-slate-600 leading-relaxed mt-3">
          Ustayla, işveren ile usta arasındaki gerçek hizmet sözleşmesinin veya hizmet bedelinin tarafı <b>değildir</b>.
          İşin yapılmasını, fiyatını veya taraflar arasındaki gerçek ödemeyi yönetmez. Hizmet bedeli, sözleşme ve ödeme
          tarafların kendi arasında gerçekleşir. Ustayla bu bedeli tahsil etmez, saklamaz veya ustaya ödemez.
        </p>
        <p className="text-slate-600 leading-relaxed mt-3">
          Ustayla'nın gelir modeli, ustanın işverenin doğrudan iletişim bilgisini açabilmek için kullandığı ücretli
          iletişim açma hizmetidir.
        </p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 mt-6">
        {[
          { icon: MessageSquare, t: "Dahili Mesajlaşma", d: "Taraflar platform üzerinden güvenle iletişim kurar." },
          { icon: Lock, t: "İletişim Gizliliği", d: "Telefon numarası yalnızca yetkili ustaya gösterilir." },
          { icon: Wallet, t: "Platform Cüzdanı", d: "İletişim açma için güvenli bakiye sistemi." },
          { icon: ShieldCheck, t: "Güvenli Platform", d: "Tüm kritik kontroller backend tarafında yapılır." },
        ].map((x, i) => (
          <div key={i} className="bg-white rounded-2xl border border-slate-200/80 p-5 flex gap-3">
            <span className="h-11 w-11 rounded-xl tinted flex items-center justify-center text-emerald-600 shrink-0"><x.icon className="h-5 w-5" /></span>
            <div><div className="font-bold text-slate-900">{x.t}</div><div className="text-sm text-slate-500 mt-0.5">{x.d}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}
